//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import BrigadeRequestsQueue from '../Brigade/BrigadeRequestsQueue.vue'
import PanelTable from './RequestProposedBrigadesBlocks/PanelTable.vue'

export default {
  components: {
    BrigadeRequestsQueue: BrigadeRequestsQueue,
    PanelTable
  },
  props: {
    proposedBrigades: {
      type: Array,
      default () {
        return []
      }
    },
    request: {
      type: Object,
      default: null
    },
    reinforcement: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      tabs: {
        unsuccessConditionsResults: 'Невыполненные условия',
        successConditionsResults: 'Выполненные условия',
        depositions: 'Вклад в показатель'
      },
      selectedTab: 'unsuccessConditionsResults',
      splitterMain: 35,
      splitterInside: 30,
      splitterEmployee: 50,

      brigadeInfoTabs: {
        employees: 'Сотрудники',
        stocktools: 'Мобильный склад'
      },
      brigadeInfoSelectedTab: 'employees',

      unsuccessConditionsResults: [],
      successConditionsResults: [],
      depositions: [],
      brigadeRequests: [],
      selectedBrigade: {},
      selectedReinforcement: [],

      filteredProposedBrigades: [],
      columnsProposedBrigades: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          classes: 'class-bordered',
          headerStyle: 'width: 150px; white-space: pre-wrap;'
        },
        {
          name: 'score',
          label: 'Коэффициент соответствия (%)',
          align: 'left',
          field: 'score',
          format: this.truncNumber,
          classes: 'class-bordered',
          headerStyle: 'width: 90px; white-space: pre-wrap;'
        },
        {
          name: 'currentRequestsIds',
          label: 'Кол-во заявок в очереди',
          align: 'left',
          field: 'currentRequestsIds',
          format: this.formatRequestsNumber,
          classes: 'class-bordered',
          headerStyle: 'width: 60px; white-space: pre-wrap;'
        },
        {
          name: 'workShift',
          label: 'Смена',
          align: 'left',
          field: 'workShift',
          classes: 'class-bordered',
          headerStyle: 'width: 100px; white-space: pre-wrap;'
        },
        {
          name: 'workTime',
          label: 'Время работы',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 50px; white-space: pre-wrap;'
        },
        {
          name: 'workArea',
          label: 'Направл. работ',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 60px; white-space: pre-wrap;'
        },
        {
          name: 'region',
          label: 'Регион',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 50px; white-space: pre-wrap;'
        },
        {
          name: 'employees',
          label: 'Кол-во сотр-ков',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 60px; white-space: pre-wrap;'
        },
        {
          name: 'skills',
          label: 'Квалиф. Навыки',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 55px; white-space: pre-wrap;'
        },
        {
          name: 'equipment',
          label: 'Инстр-ты Оборуд-е',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 65px; white-space: pre-wrap;'
        },
        {
          name: 'other',
          label: 'Другое',
          align: 'left',
          field: 'conditionsResultsInfo',
          classes: 'class-bordered',
          headerStyle: 'width: 55px; white-space: pre-wrap;'
        }
      ],
      pagination: {
        rowsPerPage: 0
      },
      selected: null,
      heightTable: {
        employee: 200,
        stockTools: 200,
        dispositions: 200,
        unsuccessConditionsResults: 200,
        successConditionsResults: 200,
        requests: 200,
        brigades: 200
      }
    }
  },
  watch: {
    splitterInside: function (size) {
      const blockMessage = document.getElementById('id-banner-requests-total-message')
      const heightBlockMessage = (blockMessage && blockMessage !== undefined) ? blockMessage.clientHeight : 0
      this.heightTable.dispositions = parseInt(this.$refs.refPartConditions.$el.clientHeight - this.$refs.refTabsConditions.$el.clientHeight) - 22
      this.heightTable.unsuccessConditionsResults = parseInt(this.$refs.refPartConditions.$el.clientHeight - this.$refs.refTabsConditions.$el.clientHeight) - 22
      this.heightTable.successConditionsResults = parseInt(this.$refs.refPartConditions.$el.clientHeight - this.$refs.refTabsConditions.$el.clientHeight) - 22
      this.heightTable.requests = parseInt(this.$refs.refPartRequests.$el.clientHeight - this.$refs.refTitleRequests.clientHeight - heightBlockMessage) - 22
    },
    splitterEmployee: function (size) {
      this.heightTable.employee = parseInt(this.$refs.refPartEmployees.$el.clientHeight - this.$refs.refTabsEmployee.$el.clientHeight) - 22
      this.heightTable.stockTools = parseInt(this.$refs.refPartEmployees.$el.clientHeight - this.$refs.refTabsEmployee.$el.clientHeight) - 22
      this.heightTable.brigades = parseInt(this.$refs.refPartBrigades.$el.clientHeight/* - this.$refs.refTabsBrigades.$el.clientHeight */) - 22
    }
  },
  created: function () {
    this.filteredProposedBrigades = this.proposedBrigades
    this.splitterInside += 0.01
    this.splitterEmployee += 0.01
  },
  methods: {
    /* resizeBlock: function () {
      console.log('RESIZE', this.$refs.refPartBrigades.clientHeight, this.$refs.refPartEmployees.clientHeight, this.$refs.refPartRequests.clientHeight, this.$refs.refPartConditions.clientHeight)
    }, */
    renderBrigadeName: function (brigade) {
      let name = brigade.brigadeName
      if (brigade.workAreas && brigade.workAreas.length) {
        const workAreasNames = []
        brigade.workAreas.forEach(workArea => {
          if (workArea.name) {
            workAreasNames.push(workArea.name)
          }
        })
        if (workAreasNames.length) {
          name += ' (' + workAreasNames.join(',') + ')'
        }
      }
      return name
    },
    formatRequestsNumber: function (currentRequestsIds) {
      return currentRequestsIds == null ? '' : currentRequestsIds.length
    },
    truncNumber: function (number) {
      return Math.trunc(number)
    },
    formatEmployeeSkills: function (skills) {
      const names = []
      if (skills) {
        for (let i = 0; i < skills.length; i++) {
          names.push(skills[i].name + ' (' + skills[i].level + ')')
        }
      }
      return names
    },
    formatConditionName: function (value) {
      return value ? value.name : ''
    },
    formatConditionType: function (value) {
      switch (value) {
        case 'equipment':
          return 'Оборудование'
        case 'qualification':
          return 'Квалификация'
        case 'tool':
          return 'Инструмент'
        case 'availabletool':
          return 'Наличие оборудования'
        case 'skill':
          return 'Навыки'
      }
      return ''
    },
    formatConditionTypeAction: function (value) {
      switch (value) {
        case 'alarm':
          return 'Предупреждение'
        case 'stop':
          return 'Запрет'
        case 'ignore':
          return 'Не учитывать'
      }
      return ''
    },
    formatConditionScore: function (value) {
      return value.toFixed(1)
    },
    renderDepositionValue: function (record) {
      let value = record.value.toFixed(2)
      const dimension = record.dimension
      if (dimension) {
        value += dimension
      }
      return value
    },
    formatDepositionScore: function (value) {
      return value.toFixed(2)
    },
    formatAmountMaterialesTable: function (amount) {
      if (amount) {
        let sumAmount = 0
        for (let i = 0; i < amount.length; i++) {
          sumAmount = sumAmount + amount[i]
        }
        return sumAmount
      } else {
        return 'Нет данных'
      }
    },
    formatStockNameMaterialesTable: function (stockName) {
      if (stockName) {
        return stockName.join(', ')
      } else {
        return 'Нет данных'
      }
    },
    onProposedBrigadeSelected: function (brigade) {
      this.clearBrigadeSelection()

      if (!brigade.shownRequests) {
        const targetRequestId = this.request && this.request.requestId != null ? this.request.requestId : null

        const currentRequestsIds = brigade.currentRequestsIds
        const targetDuplicated = targetRequestId && currentRequestsIds && currentRequestsIds.includes(targetRequestId) && brigade.requests.find(request => request.id == null)
        if (targetDuplicated) {
          brigade.requests = brigade.requests.filter(request => request.id != null)
        }

        const targetRequest = brigade.requests.find(request => request.id == null || request.id === targetRequestId)
        if (targetRequest) {
          targetRequest.target = true
          if (targetRequestId) {
            targetRequest.id = targetRequestId
            targetRequest.state = {
              name: this.request.bpStateName ? this.request.bpStateName : ''
            }
            targetRequest.name = this.request.name ? this.request.name : this.request.requestNumber ? 'Заявка №' + this.request.requestNumber : 'Новая заявка'
          }
        }
        const shownRequests = targetDuplicated || !targetRequest ? [] : [targetRequest]

        const activeRequests = brigade.activeRequests
        if (activeRequests) {
          for (let i = 0; i < activeRequests.length; i++) {
            activeRequests[i].active = true
            shownRequests.push(activeRequests[i])
          }
        }
        if (currentRequestsIds) {
          brigade.requests.forEach(request => {
            if (currentRequestsIds.includes(request.id) && request.id !== targetRequestId) {
              request.inBrigade = true
              shownRequests.push(request)
            }
          })
        }

        shownRequests.forEach(request => {
          if (!request.serviceObjectName) {
            if (request.target) {
              request.serviceObjectName = this.request.serviceObjectName || ''
            } else {
              request.serviceObjectName = brigade.requestsServiceObjects[request.id]
            }
          }
        })

        shownRequests.sort(function (r1, r2) {
          if (r1.startTime > r2.startTime) {
            return 1
          } else if (r1.startTime < r2.startTime) {
            return -1
          }
          return 0
        })

        brigade.transformed = true
        brigade.shownRequests = shownRequests
      }

      this.brigadeRequests = brigade.shownRequests

      const allDepositions = []
      for (let i = 0; i < brigade.requests.length; i++) {
        const request = brigade.requests[i]
        if (request.mismatchInfo) {
          const depositions = request.mismatchInfo.depositions
          for (let j = 0; j < depositions.length; j++) {
            depositions[j].requestNumber = request.number
            allDepositions.push(depositions[j])
          }
        }
      }
      this.depositions = allDepositions

      const conditions = brigade.conditions
      const unsuccessConditionsResults = brigade.unsuccessConditionsResults
      for (let i = 0; i < unsuccessConditionsResults.length; i++) {
        unsuccessConditionsResults[i].condition = conditions[unsuccessConditionsResults[i].conditionId]
      }
      this.unsuccessConditionsResults = unsuccessConditionsResults

      const successConditionsResults = brigade.successConditionsResults
      for (let i = 0; i < successConditionsResults.length; i++) {
        successConditionsResults[i].condition = conditions[successConditionsResults[i].conditionId]
      }
      this.successConditionsResults = successConditionsResults

      this.selectedBrigade = brigade

      this.setBrigadeStockTools(this.selectedBrigade)

      if (!this.reinforcement) {
        this.$emit('brigade-selected', this.selectedBrigade)
      }
    },
    onReinforcementBrigadeChecked: function () {
      this.$nextTick(() => {
        this.$emit('brigade-selected', this.proposedBrigades.filter(br => !!br.isChecked))
      })
    },
    clearBrigadeSelection: function () {
      // this.selectedRequest = null
      // this.updateButtons()
      this.$refs.requestsQueue.clear()
    },
    getConditionHtml: function (aggregatedType, conditionsResultsInfo) {
      const score = conditionsResultsInfo[aggregatedType]
      if (score === undefined) {
        return '<i class="custom-icon-check" style="color: lightseagreen;"></i>'
      } else if (score >= 5) {
        return '<i class="custom-icon-close" style="color: red;"></i>'
      } else if (score >= 1) {
        return '<i class="custom-icon-warning" style="color: #ffa207;"></i>'
      } else {
        return '<i class="custom-icon-check" style="color: lightseagreen;"></i>'
      }
    },
    setBrigadeStockTools: function (brigade) {
      axiosGet({
        url: '/service/delta/brigade/' + brigade.brigadeId + '/stocktools',
        onSuccess: (response) => {
          this.$set(brigade, 'stocktools', response.data.result)
        },
        onFailure: 'Ошибка получения мобильного склада',
        msgTarget: this
      })
    },
    getBrigadeTrClass: function (data, index) {
      if (data.alreadyAssigned) {
        return 'bg-orange-1'
        // 'brigade-tr-already-assigned' - #f6ece1;
      } else if (!this.reinforcement && data.isChecked) {
        return 'bg-lime-1'
        // 'brigade-tr-already-assigned-ri' - #f5f5da;
      } else if (!data.accessible) {
        return 'bg-pink-1'
        // 'brigade-tr-not-accessible' - #eed8de;
      }
    },
    getConditionsResults: function (name) {
      let results = []
      switch (name) {
        case 'unsuccessConditionsResults':
          results = this.unsuccessConditionsResults
          break
        case 'successConditionsResults':
          results = this.successConditionsResults
          break
        default:
          break
      }
      return results
    },
    getHeightTable: function (name) {
      let results = []
      switch (name) {
        case 'unsuccessConditionsResults':
          results = this.heightTable.unsuccessConditionsResults
          break
        case 'successConditionsResults':
          results = this.heightTable.successConditionsResults
          break
        default:
          break
      }
      return results
    }
  }
}

